module.exports = __webpack_public_path__ + "img/icoon_kampverblijf_small.db27dc16.svg";